export const SALE_VIEW_MILESTONES_CLICK = "sale_view_milestones_click"

export const SALE_VIEW_CHECKLIST_CLICK = "sale_view_checklist_click"

export const SALE_VIEW_LEADERBOARD_CLICK = 'sale_view_leaderboard_click'

export const SALE_TOOLS_CLICK = "sale_tools_click"